import React, { useContext, useEffect, useState } from 'react';
import { useDispatch } from "react-redux";
import { PortletPreferencesContext } from '../../../../lib/index.es';
import { fetchBitnamiHomeApps } from "../../../../lib/store/bitnamiHome/slice.es";
import { OFFERING_IMAGES } from '../../constants/bitnamiHome/bitnamiHomeConstants.es';
import BitnamiHome from './bitnamiHomePage/BitnamiHome.es';
import BitnamiFilters from './filter/BitnamiFilters.es';
import { SkeletonLoader } from 'common-ui-modules';
import BitnamiAppInfoModal from './appInfo/BitnamiAppInfoModal.es';

const HomePage = ({bitnamiLogoBaseUrlPath}) => {
    const dispatch = useDispatch();
    const isPreviewMode = useContext(PortletPreferencesContext);
    const [initialLoad, setInitialLoad] = useState(true);

    const [fetchAppsPayload, setFetchAppsPayload] = useState({
        searchText: '',
        offerings: '',
        showDrafts: isPreviewMode === "true" ? true : false,
        publishedVersion: isPreviewMode === "true" ? false : true,
        tags: '',
        pageSize: 19
    });

    const [isAppInfoModalVisible, setIsAppInfoModalVisible] = useState(false);
    const [appInfoRowData, setAppInfoRowData] = useState([]);

    useEffect(() => {
        const url = new URL(window.location.href);
        const params = new URLSearchParams(url.search);

        const category = params.get('category');
        const stack = params.get('stack');

        if (category) {
            setFetchAppsPayload(prevPayload => ({ ...prevPayload, tags: category }));
        }

        if (stack) {
            const offeringImage = OFFERING_IMAGES[stack];
            if (offeringImage) {
                setFetchAppsPayload(prevPayload => ({ ...prevPayload, offerings: offeringImage }));
            }
        }

        setInitialLoad(false);
    }, []);

    useEffect(() => {
        if (!initialLoad) {
            dispatch(fetchBitnamiHomeApps(fetchAppsPayload));
        }
    }, [fetchAppsPayload, initialLoad]);

    //common function 
    const constructStackCategoryCardHref = (path, isOffering) => {
        const currentUrl = new URL(window.location.href);
        const params = new URLSearchParams(currentUrl.search);

        if (isOffering) {
            params.set('stack', path);
            params.delete('category');
        } else {
            const category = path;
            if (params.has('category')) {
                params.set('category', category);
            } else {
                params.append('category', category);
            }
        }

        return `${currentUrl.pathname}?${params.toString()}`;
    };

    const handleInfoButtonClick = (rowData) => {
        setAppInfoRowData(rowData);
        setIsAppInfoModalVisible(true);
    };

    const handleCloseAppInfoModal = () => {
        setIsAppInfoModalVisible(false);
    };

    return (
        <div className="d-flex flex-column">
            <div>
                <BitnamiFilters constructStackCategoryCardHref={constructStackCategoryCardHref} fetchAppsPayload={fetchAppsPayload} setFetchAppsPayload={setFetchAppsPayload} isPreviewMode={isPreviewMode} />
            </div>
            <div className="border-top my-3"></div>
            <div>
                <BitnamiHome constructStackCategoryCardHref={constructStackCategoryCardHref} fetchAppsPayload={fetchAppsPayload} setFetchAppsPayload={setFetchAppsPayload} onInfoButtonClick={handleInfoButtonClick} showAppInfoModal={()=>setIsAppInfoModalVisible(true)} isPreviewMode={isPreviewMode}  bitnamiLogoBaseUrlPath={bitnamiLogoBaseUrlPath}/>
            </div>
            {isAppInfoModalVisible && (
                <BitnamiAppInfoModal
                    rowData={appInfoRowData}
                    title={appInfoRowData[0].applicationName}
                    handleClose={handleCloseAppInfoModal}
                />
            )}
        </div>
    );
};

export default HomePage;